import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  constructor(private readonly http: HttpClient) {}

  loadFavicon(): Observable<Blob> {
    return this.http.get(`${environment.BASE_URL}api/v1/favicon/`, {
      responseType: 'blob'
    });
  }
}
